export default {
  LIST: {
    TITLE: `Holidays list`,
    SUMMARY: ``
  },
  DELETE_BUTTON: {
    TITLE: `Delete the holiday`,
    SUMMARY: `Are you sure you want to delete this holiday?`,
    PRIMARY_ACTION: `Delete the holiday`
  },
  CREATE: `Add a holiday`,
  form: {
    CREATE: {
      TITLE: `Creation of a holiday`
    },
    EDIT: {
      TITLE: `Editing a holiday`
    },
    NAME: {
      LABEL: `Name of the holiday`,
      PLACEHOLDER: `Enter a name for the holiday.`,
      DESCRIPTION: ``
    },
    DATE: {
      LABEL: `Date`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Choose a date for the holiday.`
    },
    REGIONALTAGS: {
      LABEL: `Region`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Select the region for which the holiday is applicable.`
    },
    NAME_REQUIRED: `The name of the holiday is required.`,
    DATE_REQUIRED: `The date of the holiday is required.`
  }
}
